module.exports = __webpack_public_path__ + "static/media/mist-logo.ab638bd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mist-logo.svg
// module id = 1327
// module chunks = 0